import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

export const COSTS_ROUTE_NAMES = {
  COST_DOCUMENTS_OTHER: "Costs",
  NEW_COST_DOCUMENT_OTHER: "New cost document other",
  EDIT_COST_DOCUMENT_OTHER: "Edit cost document other",
  CONTRACTS: "Contracts",
  NEW_CONTRACT: "New contract",
  EDIT_CONTRACT: "Edit contract",
  COST_PANEL: "Cost panel",
  BUFFER: "Buffer",
};

const CostsRoutes: Array<CustomRouteConfig> = [
  {
    name: COSTS_ROUTE_NAMES.COST_DOCUMENTS_OTHER,
    path: "costs",
    component: () => import(/* webpackChunkName: "costs" */ "@/views/costs/CostDocumentsOtherView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsOtherRead] },
  },
  {
    name: COSTS_ROUTE_NAMES.NEW_COST_DOCUMENT_OTHER,
    path: "costs/new",
    component: () => import(/* webpackChunkName: "costs" */ "@/views/costs/CostDocumentOtherNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsOtherCreate] },
  },
  {
    name: COSTS_ROUTE_NAMES.EDIT_COST_DOCUMENT_OTHER,
    path: "costs/edit/:id",
    component: () => import(/* webpackChunkName: "costs" */ "@/views/costs/CostDocumentOtherEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsOtherUpdate] },
  },
  {
    name: COSTS_ROUTE_NAMES.CONTRACTS,
    path: "contracts",
    component: () => import(/* webpackChunkName: "contracts" */ "@/views/costs/ContractsView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.ContractRead] },
  },
  {
    name: COSTS_ROUTE_NAMES.NEW_CONTRACT,
    path: "contracts/new",
    component: () => import(/* webpackChunkName: "contracts" */ "@/views/costs/ContractNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.ContractCreate] },
  },
  {
    name: COSTS_ROUTE_NAMES.EDIT_CONTRACT,
    path: "contracts/edit/:id",
    component: () => import(/* webpackChunkName: "contracts" */ "@/views/costs/ContractEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.ContractUpdate] },
  },
  {
    name: COSTS_ROUTE_NAMES.COST_PANEL,
    path: "cost-panel",
    component: () => import(/* webpackChunkName: "cost-panel" */ "@/views/costs/CostPanelView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.PublicDataAccess] },
  },
  {
    name: COSTS_ROUTE_NAMES.BUFFER,
    path: "buffer",
    component: () => import(/* webpackChunkName: "buffer" */ "@/views/costs/BufferView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentBufferRead] },
  },
];

export { CostsRoutes };
export default CostsRoutes;
